import React, { useEffect, useState } from "react";
import {
  DirectionsRenderer,
} from "@react-google-maps/api";

const Direction = (props) => {

  return (
    <>
      {props.directions && (
        <DirectionsRenderer
          directions={props.directions}
          options={{
            suppressMarkers: true,
            polylineOptions: { strokeColor: "#00995c", strokeWeight: 5 },
            preserveViewport: 
            // props.typeBooking === "DeliverySampleShuttleCar" ? ((props.inforInCar.status === "ส่งสินค้าเรียบร้อย" || props.inforInCar.status === "ได้รับสินค้าเรียบร้อย") ? false : true) : 
            // false,
            false,
          }}
        />
      )}
    </>
  );
};

export default Direction;